import { render, staticRenderFns } from "./TwoFAUpdate.vue?vue&type=template&id=48108f18&scoped=true"
import script from "./TwoFAUpdate.vue?vue&type=script&lang=js"
export * from "./TwoFAUpdate.vue?vue&type=script&lang=js"
import style0 from "./TwoFAUpdate.vue?vue&type=style&index=0&id=48108f18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48108f18",
  null
  
)

export default component.exports